import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  fetchBerThongReceipt,
  fetchMyBerThongPurchases,
  type BerThongPurchase,
} from '../../services/berThongService'
import '../points/berThongGame.css'

const HistoryBerThongPage: React.FC = () => {
  const [items, setItems] = useState<BerThongPurchase[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    void (async () => {
      setLoading(true)
      try {
        const res = await fetchMyBerThongPurchases()
        if (!cancelled) setItems(res.data || [])
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : 'โหลดประวัติไม่สำเร็จ')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const openReceipt = async (item: BerThongPurchase) => {
    try {
      let url = item.receiptUrl || ''
      if (!url) {
        const res = await fetchBerThongReceipt(item.id)
        url = res.data?.receiptUrl || ''
      }
      if (!url) {
        await Swal.fire({ icon: 'info', title: 'ยังไม่มีใบเสร็จ', text: 'รายการนี้อาจซื้อก่อนระบบเก็บรูป' })
        return
      }
      await Swal.fire({
        title: 'ใบเสร็จเบอร์ทอง',
        imageUrl: url,
        imageAlt: 'ใบเสร็จ',
        width: 560,
        confirmButtonText: 'ปิด',
        showDenyButton: true,
        denyButtonText: 'เปิดแท็บใหม่',
      }).then((result) => {
        if (result.isDenied) window.open(url, '_blank', 'noopener,noreferrer')
      })
    } catch (err) {
      await Swal.fire({
        icon: 'error',
        title: 'โหลดใบเสร็จไม่สำเร็จ',
        text: err instanceof Error ? err.message : 'ลองใหม่อีกครั้ง',
      })
    }
  }

  if (loading) return <div className="htd-bt__loading">กำลังโหลดประวัติ...</div>
  if (error) return <div className="htd-bt__empty">{error}</div>

  return (
    <div className="htd-bt-hist">
      <div className="htd-bt__head">
        <h2 className="htd-bt__title">ประวัติเบอร์ทอง</h2>
        <Link to="/points/games/ber-thong" className="htd-bt__link">
          ไปซื้อเบอร์
        </Link>
      </div>

      {items.length === 0 ? (
        <div className="htd-bt__empty">ยังไม่มีประวัติการซื้อ</div>
      ) : (
        items.map((item) => {
          const betLabel = item.betType === 'top2' ? '2 ตัวบน' : '2 ตัวล่าง'
          const refunded = item.status === 'refunded' || item.sheetStatus === 'cancelled'
          return (
            <article key={item.id} className={`htd-bt-hist__item${refunded ? ' is-refunded' : ''}`}>
              <h3 className="htd-bt-hist__title">{item.sheetTitle || 'แผ่นเบอร์ทอง'}</h3>
              <p className="htd-bt-hist__meta">
                {item.sheetCode ? `${item.sheetCode} · ` : ''}
                {item.huayName || 'หวย'} · {new Date(item.createdAt).toLocaleString('th-TH')} · {betLabel} · งวด{' '}
                {item.drawDate || '-'} · {item.totalAmount} ฿
                {item.winningNumber ? ` · ผล ${item.winningNumber}` : ''}
                {item.sheetStatus === 'settled' ? ' · จ่ายแล้ว' : ''}
                {refunded ? ' · ยกเลิก · คืนเงินแล้ว' : ''}
              </p>
              <p className="htd-bt-hist__numbers">เบอร์ {item.numbers.join(', ')}</p>
              {(item.hasReceiptImage || item.receiptUrl) ? (
                <button
                  type="button"
                  className="htd-bt__link"
                  onClick={() => void openReceipt(item)}
                >
                  ดูใบเสร็จ
                </button>
              ) : null}
            </article>
          )
        })
      )}
    </div>
  )
}

export default HistoryBerThongPage
